module.exports = __webpack_public_path__ + "0a9afd9646e59ec8c7f1df9de16859f1.mp4";